import {
  doPostCartItem,
  doFetchQuote,
  doFetchCartProducts,
  doFetchTotalAmt,
  doDeleteCartProduct,
  doPutCartItem,
  doFetchCoupon,
  doApplyDiscountCode,
  doRemoveDiscountCode,
  doPostGiftCartItem,
  doPutGiftCartItem,
  doPostConfiguredCartItem,
  doPutConfiguredCartItem,
  doFetchGiftMessage,
  doPostCraneConnectionCartItem,
  convertGuestToCustomerCart,
  doQtyUpdateCartItem,
  doUpdateCCProductQuantity
} from "@/services/user_cart.service";
import { doFetchList as doFetchBuilderSessionItemList } from "@/services/builder_session_item.service";
import {
  getProductOptionByType,
  isStrictNonZeroDecimal,
  mergeCartProducts
} from "@/services/util.service";
import { doFetchByDesignProjectId } from "@/services/builder_session.service";
import { getCookieByName, removeCookieByName } from "@/services/auth";
import { getField, updateField } from "vuex-map-fields";
import { getAuthUser } from "@/services/auth";
import {
  listrakCartList,
  listrakCartListClear,
  snakeToCamel,
  isNumeric
} from "@/services/util.service";

const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;
// Module-level promise holders so multiple callers reuse the same in-flight requests
let cartFetchPromise = null;

export const userCartProduct = {
  namespaced: true,
  state: {
    cartDrawer: false,
    inProgress: false,
    fetchInProgress: false,
    cartProduct: [],
    cartProductList: [],
    productTotalAmt: [],
    productMedia: {},
    discountCodeList: [],
    errorMessage: null,
    cartProductsProgress: false,
    cartTotalAmtProgress: false,
    cartProductDetails: [],
    giftCartDetails: {
      recipientName: "",
      recipientEmail: "",
      senderMessage: "",

      giftCardAmt: ""
    },
    autoLogoutFlag: false,
    isCouponLoading: false,
    userQuoteId: null
  },
  getters: {
    getField
  },
  mutations: {
    updateField,

    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    cartProductsProgress(state, yesOrNo) {
      state.cartProductsProgress = yesOrNo;
    },
    cartTotalAmtProgress(state, yesOrNo) {
      state.cartTotalAmtProgress = yesOrNo;
    },
    setCartDrawer(state, yesOrNo) {
      state.cartDrawer = yesOrNo;
    },
    fetchInProgress(state, yesOrNo) {
      state.fetchInProgress = yesOrNo;
    },
    setCartProduct(state, product) {
      state.cartProduct = product;
    },
    setCartProductList(state, list) {
      state.cartProductList = list;
    },

    setListrakCartList(state) {
      listrakCartList(state.cartProductList);
    },
    setListrakCartListClear() {
      listrakCartListClear();
    },
    setCartProductDetails(state, details) {
      state.cartProductDetails = details;
    },
    setProductAmt(state, amt) {
      state.productTotalAmt = amt;
    },
    setCouponCodeList(state, code) {
      state.discountCodeList = code;
    },
    removeCouponCodeList(state, index) {
      state.discountCodeList.splice(index, 1);
    },
    setErrorMessage(state, err) {
      state.errorMessage = err;
    },
    setProductsMedia(state, media) {
      state.productMedia = media;
    },
    setAutoLogoutFlag(state, flag) {
      state.autoLogoutFlag = flag;
    },
    setGiftMessageData(state, giftMessage) {
      ((state.giftCartDetails.recipientName =
        giftMessage[0]?.productOption?.infoBuyRequest?.giftcardRecipientName ??
        giftMessage[0]?.recipientName),
        (state.giftCartDetails.recipientEmail =
          giftMessage[0]?.productOption?.infoBuyRequest
            ?.giftcardRecipientEmail ?? giftMessage[0]?.recipientEmail),
        (state.giftCartDetails.senderMessage =
          giftMessage[0]?.productOption?.infoBuyRequest?.giftcardMessage ??
          giftMessage[0]?.message),
        (state.giftCartDetails.giftCardAmt =
          giftMessage[0]?.productOption?.infoBuyRequest?.giftcardAmount ??
          (giftMessage[0]?.amount?.value).toString()));
    },
    isCouponLoading(state, yesOrNo) {
      state.isCouponLoading = yesOrNo;
    },
    updateCartItem(state, { index, data }) {
      state.cartProductList[index] = {
        ...state.cartProductList[index],
        ...data
      };
    },
    setUserQuoteId(state, quoteId) {
      state.userQuoteId = quoteId;
    }
  },
  actions: {
    addToCart: async ({ commit, state }, data) => {
      try {
        let result;
        commit("inProgress", true);
        if (!state.cartProductDetails.length > 0) {
          const userQuote = await doFetchQuote();
          commit("setUserQuoteId", userQuote);

          result = await doPostCartItem(
            data.sku,
            data.qty,
            data.ccid,
            data.price,
            data.personalizeDetails,
            data.builderId ? data.builderId : null,
            userQuote,
            data.optionId,
            data.optionValue
          );
          if (data.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        } else {
          let userQuote = state.userQuoteId;

          result = await doPostCartItem(
            data.sku,
            data.qty,
            data.ccid,
            data.price,
            data.personalizeDetails,
            data.builderId ? data.builderId : null,
            userQuote,
            data.optionId,
            data.optionValue
          );

          if (data.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        }
        commit("inProgress", false);
        return result;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addToConfiguredCart: async ({ commit, state }, data) => {
      try {
        commit("inProgress", true);
        let result;
        if (!state.cartProductDetails.length > 0) {
          const userQuote = await doFetchQuote();
          commit("setUserQuoteId", userQuote);
          result = await doPostConfiguredCartItem(
            data.sku,
            data.qty,
            data.typeId,
            data.optionId,
            data.optionValue,
            userQuote
          );
          if (data.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        } else {
          const userQuote = state.userQuoteId;
          result = await doPostConfiguredCartItem(
            data.sku,
            data.qty,
            data.typeId,
            data.optionId,
            data.optionValue,
            userQuote
          );
          if (data?.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        }
        commit("inProgress", false);
        commit("setCartDrawer", true);
        return result;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addToGiftCart: async ({ commit, state }, data) => {
      try {
        let result;
        commit("inProgress", true);
        if (!state.cartProductDetails.length > 0) {
          const userQuote = await doFetchQuote();
          commit("setUserQuoteId", userQuote);

          if (data.giftCartDetails) {
            result = await doPostGiftCartItem(
              data,
              userQuote,
              data.giftCartDetails
            );
          } else {
            result = await doPostGiftCartItem(
              data,
              userQuote,
              state.giftCartDetails
            );
          }

          if (data.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        } else {
          const userQuote = state.userQuoteId;
          if (data.giftCartDetails) {
            result = await doPostGiftCartItem(
              data,
              userQuote,
              data.giftCartDetails
            );
          } else {
            result = await doPostGiftCartItem(
              data,
              userQuote,
              state.giftCartDetails
            );
          }

          if (data.categoryLinkLocal) {
            let quoteItemId = localStorage.getItem(
              "quote_item_id" + data.categoryLinkLocal
            );
            localStorage.setItem("quote_item_id" + result.item_id, quoteItemId);
          }
        }
        commit("inProgress", false);
        commit("setCartDrawer", true);
        return result;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    addCraneConnectionProductToCart: async (
      { commit, state },
      { sku, qty, enteredOptions }
    ) => {
      try {
        commit("inProgress", true);
        let cartProduct = null;
        if (!(state.cartProductDetails.length > 0)) {
          const userQuote = await doFetchQuote();
          commit("setUserQuoteId", userQuote);
          cartProduct = await doPostCraneConnectionCartItem({
            sku,
            qty,
            userQuote,
            enteredOptions
          });
        } else {
          const userQuote = state.userQuoteId;
          cartProduct = await doPostCraneConnectionCartItem({
            sku,
            qty,
            userQuote,
            enteredOptions
          });
        }
        commit("inProgress", false);
        // commit('setCartDrawer', true);
        return cartProduct;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    productTotalAmt: async ({ commit }) => {
      commit("cartTotalAmtProgress", true);
      doFetchTotalAmt()
        .then((productTotalAmt) => {
          commit("cartTotalAmtProgress", false);
          commit("setProductAmt", snakeToCamel(productTotalAmt));
        })
        .catch(() => commit("cartTotalAmtProgress", false));
    },
    cartProductList: async ({ commit, state, dispatch }, builderSessionId) => {
      // ✅ if already loading → reuse SAME promise

      if (state.cartProductsProgress && cartFetchPromise) {
        return cartFetchPromise;
      }

      //commit("setCartProductList", []);
      commit("cartProductsProgress", true);

      cartFetchPromise = (async () => {
        try {
          let quoteId = state.userQuoteId;

          // ✅ ensure quoteId
          if (!quoteId) {
            quoteId = await doFetchQuote();
            commit("setUserQuoteId", quoteId);
          }

          // 🔥 STEP 1: HANDLE MERGE (ONLY ONCE)
          let guestQuoteId = await getCookieByName(crGuestQuoteId);

          if (guestQuoteId) {
            await convertGuestToCustomerCart({
              guestCartId: guestQuoteId,
              customerCartId: quoteId
            });

            removeCookieByName(crGuestQuoteId);
          }

          // 🔥 STEP 2: FETCH CART
          let cartData = await doFetchCartProducts(quoteId);
          let totals = cartData.totals;

          // Step 1: merge old + new
          const newList = snakeToCamel(cartData.items);
          let cartProductList = mergeCartProducts(state.cartProductList, newList);

          // Step 2: process items in parallel
          await Promise.all(
            cartProductList.map(async (item, i) => {
              if (
                item?.customizableOptions?.length &&
                !item.itemIds && !item.builderSessionItemList
              ) {
                const optionsList = item.customizableOptions;

                const builderSessionOne = optionsList.find(
                  (x) => x.label === "BuilderSessionId"
                );

                const designProjectId = optionsList.find(
                  (x) => x.label === "DESIGN_PROJECT_ID"
                );

                // 🔹 Builder Session Flow
                if (builderSessionOne) {
                  const sessionId = builderSessionOne.values?.[0]?.value;

                  if (sessionId) {
                    const sessionData = await doFetchBuilderSessionItemList({ sessionId });

                    if (sessionData?.length) {
                      item.thumbnailUrl = sessionData.map(a => a.thumbnail_url); // API still snake_case
                      item.itemIds = sessionData.map(a => a.id);
                    }
                  }
                }

                // 🔹 Design Project Flow
                else if (designProjectId) {
                  const value = designProjectId.values?.[0]?.value;

                  if (value) {
                    try {
                      const response = await doFetchByDesignProjectId({
                        designProjectId: value
                      });

                      const builderSession = snakeToCamel(response?.[0]);
                      if (!builderSession) return;

                      const items = builderSession.builderSessionItem || [];

                      if (builderSession.orderState === "prepare_svg") {
                        item.builderSessionItemList = items.map(x => ({
                          ...x,
                          thumbnailUrl: null
                        }));

                        dispatch("pollSessionData", {
                          designProjectId: value,
                          index: i
                        });
                      } else {
                        item.builderSessionItemList = items;
                      }

                    } catch (error) {
                      console.log("design fetch error", error);
                    }
                  }
                }
              }
            })
          );

          // ✅ commit once

          commit("setCartProductDetails", cartProductList);
          commit("setCartProductList", cartProductList);
          commit("setProductAmt", snakeToCamel(totals));

          return cartProductList;
        } catch (err) {
          commit("setCartProductList", []);
          throw err;
        } finally {
          commit("cartProductsProgress", false);
          cartFetchPromise = null; // 🔥 reset
        }
      })();

      return cartFetchPromise;
    },
    removeCartProduct: async ({ state, commit, dispatch }, itemUid) => {
      try {
        commit("cartProductsProgress", true);
        let trueOrFalse = await doDeleteCartProduct(itemUid, state.userQuoteId);
        if (trueOrFalse) {
          commit("cartProductsProgress", false);
          commit("cartTotalAmtProgress", false);
          commit("setCartDrawer", false);
          await dispatch("cartProductList");
          dispatch("setListrakCartListClear");
        }
      } catch (err) {
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToCart: async ({ commit, dispatch, state }, data) => {
      try {
        let userQuote = state.userQuoteId;
        commit("cartProductsProgress", true);
        const cartProduct = await doPutCartItem(
          data.sku,
          data.qty,
          userQuote,
          data.itemId,
          data.ccid,
          data.price,
          data.personalizeDetails
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          await dispatch("cartProductList");
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateQtyToCart: async ({ commit, dispatch, state }, data) => {
      try {
        let userQuote = state.userQuoteId;
        commit("cartProductsProgress", true);
        const cartProduct = await doQtyUpdateCartItem({
          qty: data.qty,
          quoteId: userQuote,
          itemId: data.itemId
        });
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          await dispatch("cartProductList");
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToPersonalizeCartItem: async (
      { commit, dispatch, state },
      {
        qty,
        itemId,
        perosonalizeIdValue,
        orderTotal = null,
        productOptions,
        byType,
        optionIdType,
        routeName = null,
        updateToCC = false,
        perosonalizeId = null
      }
    ) => {
      try {
        let totalPrice = "" + orderTotal;
        if (updateToCC) {
          let responseData = await doUpdateCCProductQuantity({
            orderNumber: perosonalizeIdValue,
            quantity: qty
          });
          const match = responseData.data.match(/price\s+is:\s*(\d+)/i);
          const price = match ? Number(match[1]) : null;
          totalPrice = "" + price;
        }

        if (!isStrictNonZeroDecimal(totalPrice)) {
          throw "Error in updating cart quntity, please try again later.";
        }

        if (!perosonalizeId) {
          throw "Error in updating cart quntity, please try again later.";
        }

        const customOptions = [
          { name: perosonalizeId, value: perosonalizeIdValue },
          { name: "custom_price", value: totalPrice }
        ];
        const customizableOptions = getProductOptionByType({
          productOptions,
          customOptions,
          action: "update",
          optionIdType: optionIdType,
          byType: byType
        });

        // Update cart item quantity
        const cartProduct = await doQtyUpdateCartItem({
          qty: qty,
          quoteId: state.userQuoteId,
          itemId: itemId,
          customizableOptions: customizableOptions
        });

        if (!cartProduct) return null;

        // UI updates
        if (routeName !== "CartProducts") {
          commit("setCartDrawer", true);
        }

        commit("setCartProduct", cartProduct);

        // Refresh cart state
        await dispatch("cartProductList");

        return cartProduct;
      } catch (err) {
        console.error("updateToCraneConectionCart failed:", err);
        throw err;
      }
    },

    updateToConfiguredCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("cartProductsProgress", true);
        let userQuoteId = state.userQuoteId;
        const cartProduct = await doPutConfiguredCartItem(
          data.sku,
          data.qty,
          userQuoteId,
          data.itemId,
          data.optionId,
          data.optionValue
        );
        if (cartProduct) {
          commit("cartProductsProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList");
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("cartProductsProgress", false);
        throw err;
      }
    },
    updateToGiftCart: async ({ commit, dispatch, state }, data) => {
      try {
        commit("inProgress", true);
        data.userQuote = state.userQuoteId;
        const cartProduct = await doPutGiftCartItem(
          data,
          data.userQuote,
          state.giftCartDetails
        );
        if (cartProduct) {
          commit("inProgress", false);
          if (data.routeName != "CartProducts") {
            commit("setCartDrawer", true);
          }
          commit("setCartProduct", cartProduct);
          dispatch("cartProductList");
          return cartProduct;
        }
      } catch (err) {
        await dispatch("cartProductList");
        commit("inProgress", false);
        throw err;
      }
    },
    cartDrawer: async ({ commit }, flag) => {
      commit("setCartDrawer", flag);
    },
    fetchCartCouponList: async ({ commit, state }) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        if (!state.userQuoteId) {
          const userQuote = await doFetchQuote();
          commit("setUserQuoteId", userQuote);
        }

        let coupon = await doFetchCoupon(state.userQuoteId);
        if (coupon && coupon.length) {
          commit("setCouponCodeList", coupon);
        } else {
          commit("setCouponCodeList", []);
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    applyDiscountCode: async ({ commit, dispatch }, code) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        const quoteId = await doFetchQuote();
        let coupon = await doApplyDiscountCode(code, quoteId);
        commit("fetchInProgress", false);
        if (coupon) {
          dispatch("fetchCartCouponList");
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },

    removeDiscountCode: async ({ commit, dispatch }, code) => {
      commit("isCouponLoading", true);
      commit("cartTotalAmtProgress", true);
      try {
        const quoteId = await doFetchQuote();
        let coupon = await doRemoveDiscountCode(code, quoteId);
        if (coupon) {
          dispatch("fetchCartCouponList");
        }
      } catch (err) {
        throw err;
      } finally {
        commit("isCouponLoading", false);
        commit("cartTotalAmtProgress", false);
      }
    },
    fetchGiftMessage: async ({ commit, state }, data) => {
      try {
        commit("fetchInProgress", true);
        let userQuote = await doFetchQuote();
        const giftMessageData = await doFetchGiftMessage(
          userQuote,
          data.itemId
        );
        if (giftMessageData) {
          commit("fetchInProgress", false);
          commit("setGiftMessageData", snakeToCamel(giftMessageData));
        }
      } catch (err) {
        commit("fetchInProgress", false);
        throw err;
      }
    },

    checkUserToken: ({ commit, dispatch }, obj) => {
      let timeInterval = null;
      timeInterval = setInterval(() => {
        if (!getAuthUser()) {
          console.log("setInterval", timeInterval, obj);
          commit("setCartProductList", []);
          commit("setProductAmt", {});
          commit("setAutoLogoutFlag", true);
          // dispatch("auth/logout", {}, { root: true });
          clearInterval(timeInterval);
        }
      }, 3000);
    },

    setListrakCartList: async ({ commit, state }) => {
      if (state.cartProductList.length > 0) {
        commit("setListrakCartList");
      }
    },
    setListrakCartListClear: async ({ commit, state }) => {
      if (state.cartProductList.length <= 0) {
        commit("setListrakCartListClear");
      }
    },
    cartTotalAmtProgress({ commit }, yesOrNo) {
      commit("cartTotalAmtProgress", yesOrNo);
    },
    pollSessionData: async (
      { commit },
      { designProjectId, index, interval = 2000, maxTries = 20 }
    ) => {
      let tries = 0;

      const pollInterval = setInterval(async () => {
        try {
          tries++;
          let response = await doFetchByDesignProjectId({
            designProjectId
          });
          let builderSession = response.length > 0 ? response[0] : null;
          console.log("builderSession order state", builderSession.order_state);
          if (builderSession.order_state !== "prepare_svg") {
            console.log(
              "builderSession order state changed",
              builderSession.order_state
            );
            clearInterval(pollInterval);
            if (
              builderSession &&
              builderSession.builder_session_item.length > 0
            ) {
              let builderSessionItemList =
                builderSession.builder_session_item.map((item) => ({
                  ...item,
                  thumbnailUrl: item.thumbnail_url
                }));

              commit("updateCartItem", {
                index: index,
                data: { builderSessionItemList: builderSessionItemList }
              });
            }
          } else if (tries >= maxTries) {
            console.warn(
              "Session data not found after 10 tries, stopping poll."
            );
            clearInterval(pollInterval);
          }
        } catch (err) {
          console.error("Error polling session data:", err);
          clearInterval(pollInterval);
        }
      }, interval);

      return pollInterval; // so you can clear it manually if needed
    },
    setUserQuoteId: async ({ commit }, quoteId) => {
      commit("setUserQuoteId", quoteId);
    }
  }
};
